<template>
  <div class="ofs-sidebar-orphan">
    <span class="ofs-sidebar-orphan__name">{{ name }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { UNKNOWN_VALUE } from '@/const'

type Props = {
  element: string
}

const props = defineProps<Props>()
  
const nameFormatter = inject<(name: string) => string>('nameFormatter')

const name = computed(() => nameFormatter?.(props.element) || UNKNOWN_VALUE)

</script>

<style>
.ofs-sidebar__unorganized .ofs-sidebar__tree-item-name,
.ofs-sidebar-orphan {
  @apply flex items-center justify-between shrink-0;
  @apply py-1.5 px-2.5 gap-2;
  @apply border border-common-border;
  @apply rounded-md;
  @apply bg-body;
  @apply text-sm;
  @apply truncate;
  @apply cursor-move;
}

.ofs-sidebar__unorganized .ofs-sidebar__tree-item-name {
  @apply opacity-50;
}
</style>
